import React, { useState } from "react";
import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import eidWish from "../../images/eidWish.jpg";
import pkFlag from "../../images/pkFlag.webp";

export const NoticeModal = () => {
  const location = useLocation();

  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const accept = () => {
    localStorage.setItem("disclaimer", true);
    handleCloseMore();
  };

  useEffect(() => {
    // let check = localStorage.getItem("disclaimer");
    if (
      location.pathname.includes("/admin") ||
      location.pathname.includes("admin-login") ||
      location.pathname.includes("super-admin-login") ||
      location.pathname.includes("waqar-login")
    ) {
    } else {
      handleShowMore();
    }

    // if (check == "true") {
    // } else {
    //   handleShowMore();
    // }
  }, []);

  return (
    <Modal show={showMore} centered>
      <Modal.Body>
        <div className="otpModalMain broadcastModal">
          <div className="closeIcon" onClick={handleCloseMore}>
            <i className="fa-solid fa-xmark" />
          </div>

          <div className="showMoreModalM">
            <div className="showMoreModal">
              {/* <div className="eidModalImg">
                <img src={eidWish} alt="eid mubarak" />
              </div> */}
              <h4 className="my-3 text-center">Important Notice</h4>
              <p className="desc1 mb-3">
                <b>📢 Session Time Update</b>
              </p>
              <p className="desc1 mb-3">Our live session time has changed!</p>
              <p className="desc1 ">🕕 New Timing: 6:30 PM PKT</p>
              <p className="desc1 ">🕕 New Timing: 9:00 PM PKT</p>
              <p className="desc1 mb-3">📅 Days: Monday to Friday</p>
              <p className="desc1 mt-3 ">
                Please note: Saturday and Sunday – No session.
              </p>

              <p className="desc1 mt-3 ">Thank you for staying with us! </p>
              <p className="desc1  ">Team Waqar Zaka.</p>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
